import React, { useState, useContext } from 'react';
import { TextField, Button, Typography } from '@mui/material';
import ErrorDialog from '../ErrorDialog';
import { AuthContext } from '../AuthContextProvider';
import { fetchJson } from '../utils/RpcUtils';
import '../App.css';

const launchZoom = (meetingId, password, caller) => {
  const encodedCaller = encodeURIComponent(caller);
  const zoomUrl = `zoomus://zoom.us/start?confno=${meetingId}&pwd=${password}&uname=${encodedCaller}`;
  const fallbackUrl = `https://zoom.us/j/${meetingId}?pwd=${password}&uname=${encodedCaller}`;

  // Try deep link
  window.open(zoomUrl, '_blank');

  // Fallback to web Zoom after short delay
  setTimeout(() => {
    window.open(fallbackUrl, '_blank');
  }, 3000);
};

const ZoomNow = () => {
  const [started, setStarted] = useState(false);
  const [meetingId, setMeetingId] = useState('');
  const [meetingPassword, setMeetingPassword] = useState('');
  const [errorMessage, setErrorMessage] = useState('');
  const [openErrorDialog, setOpenErrorDialog] = useState(false);
  const { user } = useContext(AuthContext);

  const handleClose = () => {
    setOpenErrorDialog(false);
  };

  const zoomNow = async () => {
    setStarted(true);
    try {
      const trimmedId = meetingId.replace(/\D/g, '');
      const caller = `${user.first} ${user.last}`;
      const creds = new URLSearchParams();
      creds.append('user', user.caringFor.email);
      creds.append('id', trimmedId);
      creds.append('password', meetingPassword);
      creds.append('caller', caller);
      await fetchJson('/itvs-site/zoom-call', {
        method: "post",
        headers : {
          'Accept': 'application/json'
        },
        body: creds,
      });
      launchZoom(trimmedId, meetingPassword, caller);
    } catch (err) {
      console.error(err);
      setErrorMessage(`failed to zoom-call ${err}`);
      setOpenErrorDialog(true);
    }
  };

  if (!user.caringFor) {
    return (
      <div className="VideoConferenceEventDetails">
        <Typography variant="h6" gutterBottom>
          <a href = "../home">Select a user</a>
        </Typography>
      </div>
    );
  }

  return (
    <div className="VideoConferenceEventDetails">
      <Typography variant="h6" gutterBottom>
        Zoom With {`${user.caringFor.first} ${user.caringFor.last}`}
      </Typography>
      <Typography>
        Make sure that Zoom is installed prior to pressing START.<br/>
        If Zoom fails to launch (iPad or iPhone) then be sure to manually start the Zoom meeting.<br/>
        <b>Note: </b>It may take up to two and a half minutes for {`${user.caringFor.first} ${user.caringFor.last}`} to join.
      </Typography>
      <TextField className="TextField"
        label="Meeting Id"
        value={meetingId}
        onChange={(e) => setMeetingId(e.target.value)}
      />
      <TextField className="TextField"
        label="Password"
        value={meetingPassword}
        onChange={(e) => setMeetingPassword(e.target.value.trim())}
      />
      <Button className="Button" variant="contained" color="primary" 
        disabled = {started || meetingId === '' || meetingPassword === ''}
        onClick={() => {zoomNow();}}>
        Start
      </Button>
      <ErrorDialog open={openErrorDialog} onErrorDialogClose={handleClose} errorMessage={errorMessage} />
    </div>
  );
};

export default ZoomNow;
